import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputComponent } from "@components/input/input.component";
import { TreeSelectorComponent } from "@components/tree-selector/tree-selector.component";
import { firstValueFrom } from "rxjs";
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { AreaSelectionMarknadsomrade } from "~app/common/models/areaSelector";
import { LanDTO } from "~app/common/models/distrikt/LanDTO";
import { RegelverkGridService } from "~app/features/regelverk-viol/regelverk-grid.service";
import { RegelverkViolService } from "~app/features/regelverk-viol/regelverk-viol.service";
import { IRegelverkViol3SearchModel, StyrtabellMatinformationViewModel } from "../../regelverkViol3.models";
import { RegelverkViol3Service } from "../../regelverkViol3.service";
import { MatinfoComponent } from "../matinfo.component";

@Component({
    selector: "rask-matinfo-search",
    templateUrl: "./matinfo-search.component.html",
    styleUrl: "./matinfo-search.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent,
        FormsModule,
        TreeSelectorComponent,
        ButtonComponent,
        MatinfoComponent
    ]
})
export class MatinfoSearchComponent  implements OnInit {
    readonly webbInstallningKey = "regelverkviol3.matningsinformation.filter";

    dataLoaded = false;
    lkd: LanDTO[];
    searchFilterVerksamhetsOmraden: SelectionItem[] = [];
    searchModel = this.getEmptySearch();
    searchResult: StyrtabellMatinformationViewModel[] = [];
    verksamhetsomraden: AreaSelectionMarknadsomrade[];

    private readonly regelverkGridService = inject(RegelverkGridService);
    private readonly regelverkService = inject(RegelverkViolService);
    private readonly regelverkViol3Service = inject(RegelverkViol3Service);

    ngOnInit(): void {
        firstValueFrom(this.regelverkViol3Service.getMarknadsOmraden()).then((verksamhetsomradenResponse) => {
            this.verksamhetsomraden = verksamhetsomradenResponse;
            const tmpSearchModel = this.regelverkViol3Service.getSearchFilter(this.webbInstallningKey);
            if (tmpSearchModel) {
                this.searchModel = tmpSearchModel;
            }

            this.searchFilterVerksamhetsOmraden
                        = this.regelverkGridService.mapSelectionItemsVerksamhetsomraden(verksamhetsomradenResponse, this.searchModel.selectedMoRoPo);
            firstValueFrom(this.regelverkViol3Service.getLkd()).then((lkd) => {
                this.lkd = lkd;
                this.dataLoaded = true;
                this.search();
            });
        });
    }

    protected comparePredicate = (a, b) => a.value === b;

    protected search() {
        this.searchModel.selectedMoRoPo = this.regelverkService.getSelectedVerksamhetsomraden(this.searchFilterVerksamhetsOmraden);
        this.regelverkViol3Service.saveSearchFilter(this.searchModel, this.webbInstallningKey);
        firstValueFrom(this.regelverkViol3Service.searchMatinformation(this.searchModel, this.regelverkService.mapToSelectedVerksamhetsomrade(
            this.searchModel.selectedMoRoPo,
            this.verksamhetsomraden))).then((res) => {
            const tmpSearchresult: StyrtabellMatinformationViewModel[] = [];
            res.forEach(x => {
                tmpSearchresult.push(new StyrtabellMatinformationViewModel(x, this.verksamhetsomraden, this.lkd));
            });
            this.searchResult = tmpSearchresult;
        });
    }

    private getEmptySearch(): IRegelverkViol3SearchModel {
        return { inmatningshandelssortiment: undefined,
            selectedMoRoPo: [] as any[] };
    }
}
